import type { CrmLeadCard, CrmPipelineCard } from '../../../api';
import { CRM_STALE_DAYS } from './crmLabels';

export type DealStripBadge = { label: string; color: string };

/** Liquid Glass alert orange — matches crmNavigatorLine */
export const CRM_ALERT_ORANGE = 'var(--orange, #FC814A)';

export function nextStepBadgesForOrder(card: CrmPipelineCard): DealStripBadge[] {
  const badges: DealStripBadge[] = [];
  if (!card.has_open_task) {
    badges.push({ label: 'нет задачи', color: CRM_ALERT_ORANGE });
  } else if (card.has_overdue_task) {
    badges.push({ label: 'просрочено', color: CRM_ALERT_ORANGE });
  }
  if (card.order_has_pricing_drift) badges.push({ label: 'цены', color: CRM_ALERT_ORANGE });
  if (card.days_in_stage >= CRM_STALE_DAYS) {
    badges.push({ label: `${Math.round(card.days_in_stage)}д`, color: CRM_ALERT_ORANGE });
  }
  return badges;
}

export function nextStepBadgesForLead(lead: CrmLeadCard): DealStripBadge[] {
  const badges: DealStripBadge[] = [];
  const hasOpen = Boolean(lead.has_valid_open_task || lead.has_overdue_task);
  if (!hasOpen) {
    badges.push({ label: 'нет задачи', color: CRM_ALERT_ORANGE });
  } else if (lead.has_overdue_task) {
    badges.push({ label: 'просрочено', color: CRM_ALERT_ORANGE });
  }
  return badges;
}

export function intakeSourceLabel(source: string): string {
  if (source === 'telegram') return 'TG';
  if (source === 'measurement') return 'Замер';
  if (source === 'manual') return 'Ручной';
  if (source === 'motor_quote') return 'Motor';
  if (source === 'partner') return 'Партнёрство';
  return source;
}

type StripProps = {
  title: string;
  sub: string;
  amount?: number | null;
  badges?: DealStripBadge[];
  managerLabel?: string | null;
  onClick: () => void;
};

export function CrmDealStrip({ title, sub, amount, badges = [], managerLabel, onClick }: StripProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="press w-full text-left p-3 rounded-xl touch-manipulation min-h-[44px]"
      style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid var(--border-subtle)' }}
    >
      <div className="flex items-start justify-between gap-2">
        <p className="text-xs font-bold truncate flex-1" style={{ color: 'var(--text-1)' }}>
          {title}
        </p>
        {amount != null && (
          <p className="text-xs font-bold shrink-0" style={{ color: 'var(--cyan-bright)' }}>
            {Math.round(amount || 0).toLocaleString('ru-RU')} ₽
          </p>
        )}
      </div>
      <p className="text-[10px] truncate mt-0.5" style={{ color: 'var(--text-3)' }}>
        {sub}
      </p>
      {(badges.length > 0 || managerLabel) && (
        <div className="flex flex-wrap gap-1 mt-1.5 items-center">
          {managerLabel && (
            <span
              className="text-[9px] font-bold px-1.5 py-0.5 rounded"
              style={{ background: 'rgba(99,179,237,0.15)', color: '#63B3ED' }}
            >
              {managerLabel}
            </span>
          )}
          {badges.map((b) => (
            <span
              key={b.label}
              className="text-[9px] font-bold px-1.5 py-0.5 rounded"
              style={{
                background: 'color-mix(in srgb, var(--orange, #FC814A) 20%, transparent)',
                color: b.color,
              }}
            >
              {b.label}
            </span>
          ))}
        </div>
      )}
    </button>
  );
}
